import component from './overview/SimulationInstanceOverview';

export const simulationInstance = {
    title: 'simulationInstance.title',
    path: '/simulationInstance',
    icon: 'globe',
    component
};
